import { Done, DoneAll } from "@mui/icons-material";
import { Avatar, Grid, ListItemAvatar, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { Box } from "@mui/system";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    GetAllLastChats,
    messagesReset,
} from "../../Redux/MessagesSlice/MessagesSlice";
import DesktopNotification from "../../Layouts/DesktopNotification";

const MessagesMemberBox = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    const { pusher_data } = useSelector((state) => state.pusher);
    const PusherData = pusher_data?.data || [];
    const { chats } = useSelector((state) => state.messages);
    const AllChats = chats?.data || [];
    useEffect(() => {
        const GetAllLastChatsMethod = async () => {
            await dispatch(GetAllLastChats());
            await dispatch(messagesReset());
        };
        GetAllLastChatsMethod();
    }, [dispatch]);

    const GetMessageDate = (date) => {
        const MessageDate = new Date(date).toLocaleDateString();
        return MessageDate;
    };

    // ======================
    // All Member Information To Main Box Not To Pusher Box
    // ======================
    const GetLinkID = (chat) => {
        let department_id =
            chat?.one_message?.user_sender?.role_id ||
            chat?.one_message?.user_receiver?.role_id;

        let site =
            chat?.one_message?.user_sender?.site ||
            chat?.one_message?.user_receiver?.site;

        let user_id =
            chat?.one_message?.user_sender?.id ||
            chat?.one_message?.user_receiver?.id;

        return `member-id-chat-${department_id}-${site}-${user_id}`;
    };

    const GetLinkSRC = (chat) => {
        let department_id =
            chat?.one_message?.user_sender?.role_id ||
            chat?.one_message?.user_receiver?.role_id;

        let site =
            chat?.one_message?.user_sender?.site ||
            chat?.one_message?.user_receiver?.site;

        let user_id =
            chat?.one_message?.user_sender?.id ||
            chat?.one_message?.user_receiver?.id;

        let name =
            chat?.one_message?.user_sender?.name ||
            chat?.one_message?.user_receiver?.name;

        return `${department_id}/${site}/${user_id}/${name}`;
    };

    // ======================
    // All Member Information To Pusher Box Not To Main Box
    // ======================
    const GetPusherLinkID = (chat) => {
        let department_id =
            chat?.user_sender?.role_id || chat?.user_receiver?.role_id;

        let site = chat?.user_sender?.site || chat?.user_receiver?.site;

        let user_id = chat?.user_sender?.id || chat?.user_receiver?.id;

        return `member-id-chat-${department_id}-${site}-${user_id}`;
    };

    const GetPusherLinkSRC = (chat) => {
        let department_id =
            chat?.user_sender?.role_id || chat?.user_receiver?.role_id;

        let site = chat?.user_sender?.site || chat?.user_receiver?.site;

        let user_id = chat?.user_sender?.id || chat?.user_receiver?.id;

        let name = chat?.user_sender?.name || chat?.user_receiver?.name;

        return `${department_id}/${site}/${user_id}/${name}`;
    };

    useEffect(() => {
        const appendTest = () => {
            const id = GetPusherLinkID(PusherData);
            const link = GetPusherLinkSRC(PusherData);
            const MainDiv = document.getElementById(id);
            // let name = PusherData?.user_receiver
            //     ? PusherData?.user_receiver?.name
            //     : PusherData?.user_sender?.name;
            // let department = PusherData?.user_receiver
            //     ? PusherData?.user_receiver?.site
            //     : PusherData?.user_sender?.site;
            // DesktopNotification(name, department, PusherData.body, link)
            if (MainDiv) {
                MainDiv.remove();
            }

            const NewElement =
                document.getElementsByClassName("main-member-box")[0];
            if (NewElement) {
                const parent = NewElement.parentNode;
                const helper = document.createElement("div");
                helper.innerHTML = `
                <a id="${id}" class="main-member-box" href="/messages/${link}">
                    <div class="member-box">
                        <div class="MuiGrid-root MuiGrid-container css-11lq3yg-MuiGrid-root">
                            <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-md-2 css-1qnu8s0-MuiGrid-root">
                                <div class="MuiListItemAvatar-root member-avatar css-95qvis-MuiListItemAvatar-root">
                                    <div class="MuiAvatar-root MuiAvatar-circular MuiAvatar-colorDefault css-2s90m6-MuiAvatar-root">
                                        <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiAvatar-fallback css-10mi8st-MuiSvgIcon-root-MuiAvatar-fallback" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="PersonIcon">
                                            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z">
                                            </path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-8 MuiGrid-grid-md-7 css-1cd8t37-MuiGrid-root">
                                <div>
                                    <h6 class="MuiTypography-root MuiTypography-h6 css-oblp1g-MuiTypography-root">
                                        ${
                                            PusherData?.user_receiver
                                                ? PusherData?.user_receiver
                                                      ?.name
                                                : PusherData?.user_sender?.name
                                        } 
                                    <span class="MuiTypography-root MuiTypography-span css-1vvhe1j-MuiTypography-root">
                                        - ${
                                            PusherData?.user_receiver
                                                ? PusherData?.user_receiver
                                                      ?.site
                                                : PusherData?.user_sender?.site
                                        } </span>
                                    </h6>
                                    <span class="MuiTypography-root MuiTypography-span css-19g4n3h-MuiTypography-root">
                                    ${
                                        PusherData.body
                                            ? PusherData.body.substr(0, 20)
                                            : "FILE"
                                    }
                                    </span>
                                </div>
                            </div>
                            <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4 MuiGrid-grid-md-3 read-date css-g04lnj-MuiGrid-root">
                                <p class="MuiTypography-root MuiTypography-body1 MuiTypography-alignCenter css-xzvudl-MuiTypography-root message-date">
                                        ${GetMessageDate(PusherData.created_at)}
                                </p>
                                <div class="new-message-container"><span class="new-message">1</span></div>
                            </div>
                        </div>
                    </div>
                </a>
                `;
                while (helper.firstChild) {
                    parent.insertBefore(helper.firstChild, NewElement);
                }
            } else {
                const element = document.getElementById("live-members-box");
                let member = `
                <a id="${id}" class="main-member-box" href="/messages/${link}">
                    <div class="member-box">
                        <div class="MuiGrid-root MuiGrid-container css-11lq3yg-MuiGrid-root">
                            <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-md-2 css-1qnu8s0-MuiGrid-root">
                                <div class="MuiListItemAvatar-root member-avatar css-95qvis-MuiListItemAvatar-root">
                                    <div class="MuiAvatar-root MuiAvatar-circular MuiAvatar-colorDefault css-2s90m6-MuiAvatar-root">
                                        <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiAvatar-fallback css-10mi8st-MuiSvgIcon-root-MuiAvatar-fallback" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="PersonIcon">
                                            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z">
                                            </path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-8 MuiGrid-grid-md-7 css-1cd8t37-MuiGrid-root">
                                <div>
                                    <h6 class="MuiTypography-root MuiTypography-h6 css-oblp1g-MuiTypography-root">
                                        ${
                                            PusherData?.user_receiver
                                                ? PusherData?.user_receiver
                                                      ?.name
                                                : PusherData?.user_sender?.name
                                        } 
                                    <span class="MuiTypography-root MuiTypography-span css-1vvhe1j-MuiTypography-root">
                                        - ${
                                            PusherData?.user_receiver
                                                ? " - " +
                                                  PusherData?.user_receiver
                                                      ?.site
                                                : " - " +
                                                  PusherData?.user_sender?.site
                                        } </span>
                                    </h6>
                                    <span class="MuiTypography-root MuiTypography-span css-19g4n3h-MuiTypography-root">
                                    ${
                                        PusherData.body
                                            ? PusherData.body.substr(0, 20)
                                            : ""
                                    }
                                    </span>
                                </div>
                            </div>
                            <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4 MuiGrid-grid-md-3 read-date css-g04lnj-MuiGrid-root">
                                <p class="MuiTypography-root MuiTypography-body1 MuiTypography-alignCenter css-xzvudl-MuiTypography-root message-date">
                                        ${GetMessageDate(PusherData.created_at)}
                                </p>
                                <div class="new-message-container"><span class="new-message">1</span></div>
                            </div>
                        </div>
                    </div>
                </a>
                `;
                element.innerHTML += member;
            }
        };

        if (PusherData.length !== 0) {
            appendTest();
        }
    }, [PusherData]);

    return (
        <AllMembersWithLastMessage>
            <Typography
                variant="h5"
                mt={3}
                sx={{ fontWeight: "bold" }}
                align="center"
                color="primary"
            >
                All Messages
            </Typography>

            <Box
                id="live-members-box"
                style={{
                    height: "calc(80vh)",
                    overflowY: "scroll",
                    padding: "11px",
                }}
            >
                {AllChats?.map((chat, index) => (
                    <Link
                        id={GetLinkID(chat)}
                        to={GetLinkSRC(chat)}
                        className="main-member-box"
                        key={index}
                    >
                        <div className="member-box">
                            <Grid container columns={12}>
                                <Grid
                                    item
                                    md={2}
                                    sx={{
                                        display: { md: "block", xs: "none" },
                                    }}
                                >
                                    <ListItemAvatar
                                        className="member-avatar"
                                        sx={{
                                            alignSelf: "flex-start",
                                            marginTop: "5px",
                                        }}
                                    >
                                        <Avatar src="/static/images/avatar/1.jpg" />
                                    </ListItemAvatar>
                                </Grid>
                                <Grid item md={7} xs={8}>
                                    <div>
                                        <Typography
                                            variant="h6"
                                            color="primary"
                                        >
                                            {chat?.one_message?.user_receiver
                                                ? chat?.one_message
                                                      ?.user_receiver?.name
                                                : chat?.one_message?.user_sender
                                                      ?.name}
                                            <Typography
                                                variant="span"
                                                color="gray"
                                            >
                                                {chat?.one_message
                                                    ?.user_receiver
                                                    ? " - " +
                                                      chat?.one_message
                                                          ?.user_receiver?.site
                                                    : " - " +
                                                      chat?.one_message
                                                          ?.user_sender?.site}
                                            </Typography>
                                        </Typography>
                                        <Typography
                                            variant="span"
                                            color="black"
                                        >
                                            {chat?.one_message
                                                ?.user_receiver ? (
                                                <>
                                                    <Typography
                                                        variant="span"
                                                        color="primary"
                                                    >
                                                        You :
                                                    </Typography>
                                                    {chat?.one_message?.body.substr(
                                                        0,
                                                        20
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {chat?.one_message?.body.substr(
                                                        0,
                                                        20
                                                    )}
                                                </>
                                            )}
                                        </Typography>
                                    </div>
                                </Grid>
                                <Grid className="read-date" item md={3} xs={4}>
                                    <Typography
                                        className="message-date"
                                        color="black"
                                        align="center"
                                    >
                                        {GetMessageDate(chat.last_message)}
                                    </Typography>
                                    {parseInt(chat?.one_message?.status) ===
                                    1 ? (
                                        <span className="done-all-icon">
                                            <DoneAll />
                                        </span>
                                    ) : (
                                        <>
                                            {chat?.one_message
                                                ?.user_receiver ? (
                                                <Done />
                                            ) : (
                                                <div className="new-message-container">
                                                    <span className="new-message">
                                                        1
                                                    </span>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </Grid>
                            </Grid>
                        </div>
                    </Link>
                ))}
            </Box>
            {/* )} */}
        </AllMembersWithLastMessage>
    );
};

const AllMembersWithLastMessage = styled.div`
    height: calc(80vh - 80px);
    .member-box {
        margin-top: 5px;
        padding: 7px;
        background: var(--light-sky);
        .member-avatar {
            display: flex;
            justify-content: center;
        }
        .read-date svg {
            color: gray;
            position: relative;
            left: 50%;
            transform: translate(-50%, 0);
        }
        .read-date svg.seen {
            color: var(--light-blue);
        }
        .read-date .done-all-icon svg {
            color: var(--light-blue);
        }
        .read-date .message-date {
            margin-bottom: 5px;
        }
    }
    .member-box:hover {
        background: var(--border-light);
    }
    .new-message-container {
        display: flex;
        justify-content: center;
        margin-bottom: 5px;
    }
    .new-message-container .new-message {
        background: #f00;
        padding: 1px 9px;
        border-radius: 50%;
        color: var(--white);
        font-weight: bold;
    }
`;

export default MessagesMemberBox;
